export const BACKEND_API = process.env.REACT_APP_BACK_URL;

export const IS_MAINTENANCE = process.env.REACT_APP_IS_MAINTENANCE === "true"; 